import Logger from '../common/safe-log';

const timestampTxt = () => {
    try {
        const now = new Date()
        const month = now.getMonth()
        const day = now.getDate()
        const year = now.getFullYear()
        const hh = now.getHours()
        const mm = now.getMinutes()
        const ss = now.getSeconds()

        const date = `${month}/${day}/${year}`
        const time = `${hh}:${mm}:${ss}`

        return `[${date} - ${time}]`
    } catch (error) {
        return `[${new Date().toISOString()}]`
    }
}

const guLocalStorage = (redirectUrl, winUrl, userID, update) => {
    try {
        // Flagship Data Check
        const flagshipData = JSON.parse(localStorage.getItem('FS_CLIENT_VISITOR')) || []
        const guFlagshipData = setLocalStorage(flagshipData, userID);

        let comparison = compareObjects(guFlagshipData, flagshipData)

        if ( redirectUrl !== winUrl && userID && comparison === false ) {
            // ModificationID Check
            const modID = flagshipData.campaigns[0].id
            const modGUID = guFlagshipData.campaigns[0].id
            let result = modID === modGUID;
            // ModificationID not change
            if ( result === true ) {
                Logger.info('GU FLAGSHIP DATA', guFlagshipData, 'ModificationID is the same', result);
            }
        }

        if ( userID && update === true ) {
            let guFlagshipData = updateLocalStorage(flagshipData);
            Logger.info('FS_CLIENT_VISITOR', flagshipData, 'GU FLAGSHIP DATA', guFlagshipData);
        }

    } catch (error) {
        return `Flagship Data Check Fail at - [${new Date().toISOString()}]`
    }
}

const setLocalStorage = (data, user)  => {
    //store the list back to localStorage
    data.user_id = user;
    localStorage.setItem('GU_FS_CLIENT_VISITOR', JSON.stringify(data))
    const guFsClientVisitor = JSON.parse(localStorage.getItem('GU_FS_CLIENT_VISITOR')) || []
    Logger.info('GU_FS_CLIENT_VISITOR', guFsClientVisitor);
    return guFsClientVisitor
}

const updateLocalStorage = (data)  => {
    const guFsClientVisitor = JSON.parse(localStorage.getItem('GU_FS_CLIENT_VISITOR')) || []
    localStorage.setItem('FS_CLIENT_VISITOR', JSON.stringify(data))
    return guFsClientVisitor
}

const compareObjects = (object1, object2) => {
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) {
        return false;
    }
    for (const key of keys1) {
        const val1 = object1[key];
        const val2 = object2[key];
        const areObjects = isObject(val1) && isObject(val2);
        if (
            areObjects && !compareObjects(val1, val2) ||
            !areObjects && val1 !== val2
        ) {
            return false;
        }
    }
    return true;
}

function isObject(object) {
    return object != null && typeof object === 'object';
}


export { timestampTxt, guLocalStorage }
